import { ArrowRight, ArrowDown } from "lucide-react";

const HERO_IMG = "/assets/hero-fred.jpg";

export const Hero = () => {
  const goTo = (hash) => {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden"
    >
      <div className="px-6 md:px-12 lg:px-20 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 lg:gap-12 items-end">
        <div className="md:col-span-8">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-black/70 mb-6">
            [ 001 / The Studio ]
          </p>
          <h1 className="font-display uppercase leading-[0.82] tracking-[-0.04em] text-[14vw] sm:text-[11vw] md:text-[7.5vw] lg:text-[7vw] xl:text-[8rem] 2xl:text-[9rem] break-words">
            Sound
            <br />
            <span className="italic font-light">engineered</span>
            <br />
            with intent.
          </h1>

          <p className="mt-10 max-w-xl text-base md:text-lg text-black/75 leading-relaxed">
            Professional mixing, mastering & home-recording consultation out of
            Raleigh, NC. We shape sound with precision - from raw takes to
            radio-ready masters, and teach you how to capture pro-grade
            recordings from your own space.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-contact"
              onClick={() => goTo("#contact")}
              className="group font-mono text-[11px] tracking-[0.25em] uppercase bg-black text-white px-7 py-5 border-2 border-black hover:bg-white hover:text-black transition-colors flex items-center justify-center gap-3"
            >
              Send Us an Email <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => goTo("#services")}
              className="font-mono text-[11px] tracking-[0.25em] uppercase bg-white text-black px-7 py-5 border-2 border-black hover:bg-black hover:text-white transition-colors flex items-center justify-center gap-3"
            >
              Our Services <ArrowDown size={16} />
            </button>
            <a
              href="https://engineears.com/infinagon"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-cta-book"
              className="font-mono text-[11px] tracking-[0.25em] uppercase px-7 py-5 border-2 border-black/15 hover:border-black transition-colors flex items-center justify-center gap-3"
            >
              Book via EngineEars ↗
            </a>
          </div>
        </div>

        <div className="md:col-span-4 relative">
          <div className="relative aspect-[3/4] w-full max-h-[640px] mx-auto border-2 border-black overflow-hidden grain">
            <img
              src={HERO_IMG}
              alt="Mixing console"
              className="w-full h-full object-cover grayscale"
            />
            <div className="absolute inset-0 mix-blend-multiply bg-white/10" />
            <div className="absolute bottom-0 left-0 right-0 bg-black text-white px-4 py-3 font-mono text-[10px] tracking-[0.25em] uppercase flex justify-between">
              <span>IR/STD/001</span>
              <span>■ LIVE</span>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-20 md:mt-28 border-y-2 border-black overflow-hidden bg-white">
        <div className="flex whitespace-nowrap marquee-track py-5 font-display text-4xl md:text-6xl uppercase tracking-tighter">
          {Array.from({ length: 2 }).flatMap((_, i) =>
            ["Mixing", "Mastering", "Consultations", "Production"].map((w, j) => (
              <span key={`${i}-${j}`} className="px-8 flex items-center gap-8">
                {w}
                <span className="inline-block w-3 h-3 bg-black rounded-full" />
              </span>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
